export default __webpack_public_path__ + "static/media/art_image4.18295405.jpg";